<template>
  <div>
    <v-container>
      <div class="status-rights-label">
        {{$t('status_rights.user_rights')}}
      </div>
      <v-layout>
        <v-flex>
          <v-select v-model="selectedUserType" :items="userTypes" :label="$t('status_rights.user_type')" solo></v-select>
        </v-flex>
        <v-flex>
          <v-select
            v-model="selectedTableName"
            :items="tableNames"
            :label="$t('status_rights.table')"
            v-on:input="getStatusNames"
            solo
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout v-if="showStatusRights">
        <v-data-table
          :headers="headers"
          :items="statuses"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ props.item.text }}</td>
            <td class="text-xs-right">
              <input
                type="checkbox"
                :checked="shouldBeChecked(props.item, 0)"
                @change="tick(props.item, $event, 0)"
              >
            </td>
            <td class="text-xs-right">
              <input
                type="checkbox"
                :checked="shouldBeChecked(props.item, 1)"
                @change="tick(props.item, $event, 1)"
              >
            </td>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    tickedBoxes: null,
    statuses: [],
    statusRightsDatabase: {},
    userTypes: [0, 1, 2, 3, 4, 5],
    tableNames: ["Užsakymai", "Produktai", "Paletės", "Sunkvežimiai"],
    selectedUserType: null,
    selectedTableName: null,
    pagination: {
      rowsPerPage: 20
    },
    headers: [
      {
        text: "Statusas",
        align: "left",
        sortable: false,
        value: "name"
      },
      { text: "Iš", value: "calories", sortable: false },
      { text: "Į", value: "fat", sortable: false }
    ]
  }),
  created() {
    this.getStatusRights();
  },
  computed: {
    showStatusRights() {
      if (this.selectedTableName != null && this.selectedUserType != null) {
        return true;
      }
      return false;
    }
  },
  watch: {
    selectedUserType: {
      handler() {
        if (this.selectedTableName != null) {
          this.initTickedBoxes(this.statuses);
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * gets status names to choose from
     */
    getStatusNames() {
      this.requestStatusNames().then((response)=> {
        if (response.status == 200) {
          this.statuses = response.data;
          this.initTickedBoxes(this.statuses);
        }
      });
    },

    /**
     * http request to get status names
     */
    requestStatusNames() {
      let params = {
        language: this.$i18n.locale,
        table_name: this.getTableName()
      };
      return this.$http.get(process.env.VUE_APP_ROOT_API + "/statuses", {
        headers: {
          Authorization: "Bearer" + " " + this.$session.get("jwt")
        },
        params
      });
    },

    /**
     * gets all of the companies status rights
     */
    getStatusRights() {
      this.requestStatusRights().then((response)=> {
        if (response.status == 200) {
          this.statusRightsDatabase = response.data;
        }
      });
    },

    /**
     * http request status rights
     */
    requestStatusRights() {
      return this.$http.get(process.env.VUE_APP_ROOT_API + "/status-rights", {
        headers: {
          Authorization: "Bearer" + " " + this.$session.get("jwt")
        }
      });
    },

    /**
     * gets table name from selection
     * @return table name to be retrieved from
     * the database according to selection
     */
    getTableName() {
      switch (this.selectedTableName) {
        case "Užsakymai":
          return "orders";
        case "Produktai":
          return "products";
        case "Paletės":
          return "pallets";
        case "Sunkvežimiai":
          return "trucks";
        default:
          return "";
      }
    },

    /**
     * creates an empty matrix (will need to get
     * matrix with actual current status rights in the future)
     * @param statusRightNames - status right names gotten from array
     */
    initTickedBoxes(statusRightNames) {
      let matrix = [];
      for (let i = 0; i < statusRightNames.length; i++) {
        matrix[i] = [];
        for (let j = 0; j < 2; j++) {
          matrix[i][j] = 0;
        }
      }
      this.tickedBoxes = matrix;
    },

    /**
     * returns true if rules are ticked
     */
    shouldBeChecked(item, side) {
      if (side == 0) {
        if (this.tickedBoxes[item["status"]][0] == 1) {
          return true;
        }
      }
      if (side == 1) {
        if (this.tickedBoxes[item["status"]][1] == 1) {
          return true;
        }
      }
      for (let i = 0; i < this.statusRightsDatabase.length; i++) {
        if (side == 0) {
          if (
            this.statusRightsDatabase[i]["before"] == item["status"] &&
            this.statusRightsDatabase[i]["table_name"] == this.getTableName() &&
            this.statusRightsDatabase[i]["user_type"] == this.selectedUserType
          ) {
            this.tickedBoxes[item["status"]][0] = 1;
            return true;
          }
        }
        if (side == 1) {
          if (
            this.statusRightsDatabase[i]["after"] == item["status"] &&
            this.statusRightsDatabase[i]["table_name"] == this.getTableName() &&
            this.statusRightsDatabase[i]["user_type"] == this.selectedUserType
          ) {
            this.tickedBoxes[item["status"]][1] = 1;
            return true;
          }
        }
      }
      return false;
    },

    /**
     * converts current ticked checkboxes to needed statuses
     * then compares them to the ones in the database and updates accordingly
     * @param item - status Right object
     * @param $event - ticked true or false
     * @param side - 0 ticked from, 1 - ticked to
     */
    tick(item, checkbox, side) {
      let checkboxValue = checkbox.target.checked;
      //update ticked boxes matrix
      if (side == 0) {
        checkboxValue
          ? (this.tickedBoxes[item["status"]][0] = 1)
          : (this.tickedBoxes[item["status"]][0] = 0);
      }
      if (side == 1) {
        checkboxValue
          ? (this.tickedBoxes[item["status"]][1] = 1)
          : (this.tickedBoxes[item["status"]][1] = 0);
      }
      //parse ticked boxes matrix to what database entries should be
      let updatedDatabase = [];
      for (let i = 0; i < this.tickedBoxes.length; i++) {
        //if selected 'from' check all selected 'to'
        if (this.tickedBoxes[i][0] == 1) {
          for (let j = 0; j < this.tickedBoxes.length; j++) {
            //if selected 'to'
            if (this.tickedBoxes[j][1] == 1)
              updatedDatabase.push({
                user_type: this.selectedUserType,
                before: this.statuses[i]["status"],
                after: this.statuses[j]["status"],
                table_name: this.getTableName()
              });
          }
        }
      }
      //wipe existing
      this.deleteOld(this.selectedUserType, this.getTableName()).then(() => {
        if (updatedDatabase.length > 0) {
          //add new
          setTimeout(() => {
            this.addNew(updatedDatabase);
            this.getStatusRights();
          }, 50);
        }
      });
    },

    /**
     * deletes all rules from statusRights for users company
     * by given user type and table name
     *
     * @param userType
     * @param tableName
     */
    deleteOld(userType, tableName) {
      let data = {
        table_name: tableName,
        user_type: userType
      };

      return this.$http.post(
        process.env.VUE_APP_ROOT_API + "/status-rights/delete",
        data,
        {
          headers: {
            Authorization: "Bearer" + " " + this.$session.get("jwt")
          }
        }
      );
    },

    /**
     * adds new rights to the database
     * @param updatedDatabase
     */
    addNew(updatedDatabase) {
      let data = {
        updated: JSON.stringify(updatedDatabase)
      };
      let headers = {
        Authorization: "Bearer" + " " + this.$session.get("jwt")
      };

      this.$http.post(process.env.VUE_APP_ROOT_API + "/status-rights/all", data, {
        headers
      });
    }
  }
};
</script>

<style scoped>
.status-rights-label{
  margin-left: 5px;
  font-weight: bold;
  
}
</style>
